import {
  OveragesSubscription,
  Subscription,
} from '@basehub/data/replicache/index'
import { addDays, differenceInDays, startOfDay } from 'date-fns'
import type Stripe from 'stripe'

export const PERIOD_DAYS = 30

export function calculatePeriodStartAtForNoSubscribedPlans({
  teamCreatedAt,
}: {
  teamCreatedAt: Date
}) {
  const now = new Date()

  // Start from beginning of the creation day to avoid time-of-day complications
  const cleanStart = startOfDay(teamCreatedAt)

  // Calculate how many complete 30-day periods have passed
  const daysSinceCreation = differenceInDays(now, cleanStart)
  const completedPeriods = Math.floor(daysSinceCreation / PERIOD_DAYS)

  // Calculate the start of the current period
  const currentPeriodStart = addDays(cleanStart, completedPeriods * PERIOD_DAYS)

  return currentPeriodStart
}

export function buildBaseSubscription({
  stripeSubscription,
  customerEmail,
}: {
  stripeSubscription: Stripe.Subscription
  customerEmail: string | null
}): Subscription {
  return {
    id: stripeSubscription.id,
    status: stripeSubscription.status as 'active',
    customerId:
      typeof stripeSubscription.customer === 'string'
        ? stripeSubscription.customer
        : stripeSubscription.customer.id,
    canceledAt: stripeSubscription.canceled_at
      ? new Date(stripeSubscription.canceled_at * 1000).toISOString()
      : null,
    customerEmail,
    currentPeriodEndAt: new Date(
      stripeSubscription.current_period_end * 1000
    ).toISOString(),
    currentPeriodStartAt: new Date(
      stripeSubscription.current_period_start * 1000
    ).toISOString(),
    created: stripeSubscription.created
      ? stripeSubscription.created * 1000
      : undefined,
  }
}

export function buildOveragesSubscription({
  stripeSubscription,
  customerEmail,
}: {
  stripeSubscription: Stripe.Subscription
  customerEmail: string | null
}): OveragesSubscription {
  return {
    ...buildBaseSubscription({ stripeSubscription, customerEmail }),
    usageRecords: {
      apiRequests: {
        limit: null,
        status: 'active',
      },
      blocks: {
        limit: null,
      },
      assetApiRequests: {
        limit: null,
        status: 'active',
      },
      assetStorage: {
        limit: null,
        status: 'active',
      },
    },
  }
}
